import React from 'react';
import WaterSimulationContainer from 'modules/misc/WaterSimulationContainer.js';
import GroupSelect from 'modules/authentication/GroupSelect.js';
import EnterGroupCodeContainer from 'modules/authentication/EnterGroupCodeContainer.js';

const style={
    container: {
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        maxWidth: '500px',
        marginLeft: 'auto',
        marginRight: 'auto',
    }
};

const TestPage = (props) => (
    <div style={style.container}>
        <EnterGroupCodeContainer />
    </div>
);

export default TestPage;



// WEBPACK FOOTER //
// ./src/modules/misc/TestPage.js